import React from 'react';
import {roundTo} from 'round-to';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import {isDirectBilling} from '../../helpers/cases';

const getTotal = ({rate, copay, formValues, session}) => {
  const formDiscount = parseFloat(formValues.session_discount);
  const priorDiscount = parseFloat(session.discount);
  const sessionDiscount = (
    !isNaN(formDiscount)
    ? formDiscount
    : (isNaN(priorDiscount) ? 0 : priorDiscount)
  );
  const percentToCharge = (1 - .01 * roundTo(sessionDiscount, 8));
  let total = (
    isDirectBilling(session?.case) && session?.category !== 'optimize'
    ? roundTo(
      parseFloat(copay)
      * percentToCharge,
      2
    )
    : roundTo(
      parseInt(rate, 10)
      * (
        (
          formValues.session_duration
          ? parseInt(formValues.session_duration, 10)
          : parseInt(session.duration, 10)
        ) / 60
      )
      * percentToCharge,
      2
    )
  );
  // handle cases with no decimal point like "1"
  if (!/\./.test(total.toString())) return total + '.00';
  // handle cases with a decimal point and just one digit like "1.5"
  if (/\.\d$/.test(total.toString())) return total + '0';
  if (/\.[\d]{2,2}$/.test(total.toString())) return total;
  return total.toString() + '0';
};

const BillingCalculator = ({rate, copay, session, formValues}) => (
  <Box sx={{ backgroundColor: config().colors.background, padding: '0.8rem'}}>
    <Stack>
      <Stack direction='row' alignItems='center' spacing={2} marginBottom={1.5}>
        <Typography variant='paragraphMedium' color='text.light'>
          {isDirectBilling(session?.case) && session?.category !== 'optimize' ? 'Copay:' : 'Provider Rate:'}
        </Typography>
        <Typography variant='paragraphMedium'>
          {
            isDirectBilling(session?.case) && session?.category !== 'optimize'
            ? `$${copay}`
            : `$${rate}/hr`
          }
        </Typography>
      </Stack>
      <Stack direction='row' alignItems='center' spacing={2}>
        <Typography variant='paragraphMedium' color='text.light'>
          Total:
        </Typography>
        <Typography variant='paragraphMedium'>
          ${getTotal({rate, copay, session, formValues})}
        </Typography>
      </Stack>
    </Stack>
  </Box>
);

export default BillingCalculator;